import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { HeadingTagType } from "@lexical/rich-text";
import { MenuItem, Select } from "@mui/material";
import {
  blockTypeToBlockName,
  formatBulletList,
  formatHeading,
  formatNumberedList,
  formatParagraph,
  ToolbarState,
} from "./utils";

const ToolBarSelect = ({
  blockType,
  setToolbarState,
  toolbarState,
}: {
  blockType: string;
  setToolbarState: (state: ToolbarState) => void;
  toolbarState: ToolbarState;
}) => {
  const [editor] = useLexicalComposerContext();

  const dropDownActiveClass = (active: boolean) => {
    if (active) {
      return "active dropdown-item-active";
    } else {
      return "";
    }
  };

  return (
    <Select
      value={blockType}
      onChange={(value) => {
        const tag = value.target.value;
        if (tag === "paragraph") {
          formatParagraph(editor);
          setToolbarState({ ...toolbarState, blockType: "paragraph" });
        } else if (tag === "number") {
          formatNumberedList(editor, tag);
          setToolbarState({ ...toolbarState, blockType: "number" });
        } else if (tag === "bullet") {
          formatBulletList(editor, tag);
          setToolbarState({ ...toolbarState, blockType: "bullet" });
        } else {
          formatHeading(editor, blockType, tag as HeadingTagType);
          setToolbarState({
            ...toolbarState,
            blockType: tag as keyof typeof blockTypeToBlockName,
          });
        }
      }}
      className="toolbar-item block-controls"
      sx={{
        "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input":
          {
            zIndex: 1000,
            paddingLeft: "4px",
          },
        "& .MuiSelect-select": {
          paddingY: "8px",
          width: "fit-content",
          minWidth: "60px",
        },
        "& .MuiOutlinedInput-notchedOutline, &.MuiInputBase-root": {
          height: "100%",
        },
      }}
    >
      <MenuItem
        value="paragraph"
        className={
          "item wide " + dropDownActiveClass(blockType === "paragraph")
        }
      >
        Normal
      </MenuItem>
      <MenuItem
        value="h1"
        className={"item wide " + dropDownActiveClass(blockType === "h1")}
      >
        Heading 1
      </MenuItem>
      <MenuItem
        value="h2"
        className={"item wide " + dropDownActiveClass(blockType === "h2")}
      >
        Heading 2
      </MenuItem>
      <MenuItem
        value="h3"
        className={"item wide " + dropDownActiveClass(blockType === "h3")}
      >
        Heading 3
      </MenuItem>
      <MenuItem
        value="h4"
        className={"item wide " + dropDownActiveClass(blockType === "h4")}
      >
        Heading 4
      </MenuItem>
      <MenuItem
        value="h5"
        className={"item wide " + dropDownActiveClass(blockType === "h5")}
      >
        Heading 5
      </MenuItem>
      <MenuItem
        value="h6"
        className={"item wide " + dropDownActiveClass(blockType === "h6")}
      >
        Heading 6
      </MenuItem>
      <MenuItem
        value="number"
        className={"item wide " + dropDownActiveClass(blockType === "number")}
      >
        Number List
      </MenuItem>
      <MenuItem
        value="bullet"
        className={"item wide " + dropDownActiveClass(blockType === "bullet")}
      >
        Bullet List
      </MenuItem>
    </Select>
  );
};

export default ToolBarSelect;
